import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import { CollapsibleSectionWithListener } from '@src/common/components/CollapsibleSectionWithListener';
import type { ComponentProps } from 'react';

interface Props extends Omit<
  ComponentProps<typeof CollapsibleSectionWithListener>,
  'icon'
> {
  inError?: boolean;
}

export const EditOrderCollapsible = ({ inError, ...props }: Props) => {
  return (
    <CollapsibleSectionWithListener
      {...props}
      icon={inError ? <ErrorOutlineOutlined color="error" /> : null}
    />
  );
};
